var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43442 5.43368C5.58445 5.28371 5.78789 5.19945 6.00002 5.19945C6.21216 5.19945 6.4156 5.28371 6.56562 5.43368L10 8.86808L13.4344 5.43368C13.5082 5.35728 13.5965 5.29633 13.6941 5.2544C13.7917 5.21248 13.8967 5.19041 14.0029 5.18948C14.1091 5.18856 14.2145 5.2088 14.3128 5.24903C14.4111 5.28925 14.5004 5.34865 14.5755 5.42377C14.6507 5.49888 14.7101 5.5882 14.7503 5.68652C14.7905 5.78484 14.8107 5.89018 14.8098 5.9964C14.8089 6.10263 14.7868 6.2076 14.7449 6.30521C14.703 6.40281 14.642 6.49109 14.5656 6.56488L11.1312 9.99928L14.5656 13.4337C14.7114 13.5846 14.792 13.7866 14.7902 13.9964C14.7883 14.2062 14.7042 14.4068 14.5559 14.5551C14.4076 14.7035 14.2069 14.7876 13.9971 14.7894C13.7874 14.7912 13.5853 14.7106 13.4344 14.5649L10 11.1305L6.56562 14.5649C6.41474 14.7106 6.21266 14.7912 6.0029 14.7894C5.79315 14.7876 5.5925 14.7035 5.44417 14.5551C5.29584 14.4068 5.21171 14.2062 5.20989 13.9964C5.20806 13.7866 5.2887 13.5846 5.43442 13.4337L8.86882 9.99928L5.43442 6.56488C5.28445 6.41486 5.2002 6.21142 5.2002 5.99928C5.2002 5.78715 5.28445 5.58371 5.43442 5.43368Z",
    fill: "#FF4C4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.67f5ced95d17a1c3e10b46c92ce0e200.svg";
export { ForwardRef as ReactComponent };